module.exports = __webpack_public_path__ + "img/78ne.4696634a.svg";